<template>
  <b-modal
    id="modal-case-card"
    ref="bModal"
    size="xl"
    :title="$t('global.infoCase')"
    centered
    modal-class="modalPatientCases"
  >
    <!--Case Data-->
    <b-row>
      <b-col class="form-box">
        <div class="structure">
          <div class="structure__heading">
            <i
              class="far fa-chart-network mr-2"
              aria-hidden="true"
            />
            {{ $t('registry.cases.caseData') }}
          </div>

          <b-row class="mb-1">
            <b-col
              md="3"
              cols="4"
              class="structure__data"
            >
              <small>{{ $t('component.caseCardModal.studyId') }}</small>
              <h4 class="collapsable-card-title d-flex">
                {{ caseStudy.casenumber }}
                <b-badge
                  v-if="caseStudy.caseOfReference"
                  v-tooltip="$t('registry.btn.consultation')"
                  pill
                  class="ml-1 icon-badge indicator-bubble d-flex align-items-center justify-content-center"
                >
                  <i
                    class="far fa-glasses"
                    aria-hidden="true"
                  />
                </b-badge>
              </h4>
            </b-col>
            <b-col
              md="3"
              cols="4"
              class="structure__data"
            >
              <small>{{ $t('component.caseCardModal.casRegistrationDate') }}</small>
              <h4 class="collapsable-card-title">
                {{ caseStudy.registrationDate | date }}
              </h4>
            </b-col>
            <b-col
              md="3"
              cols="4"
              class="structure__data"
            >
              <small>{{ $t('component.caseCardModal.register') }}</small>
              <h4 class="collapsable-card-title">
                {{ caseStudy.registerPersonnel }}
              </h4>
            </b-col>
            <b-col
              md="3"
              cols="4"
              class="structure__data"
            >
              <small>{{ $t('component.caseCardModal.caseType') }}</small>
              <h4 class="collapsable-card-title">
                {{ caseStudy.caseType.descriptionInLaboratory }}
              </h4>
            </b-col>
            <b-col
              md="3"
              cols="4"
              class="structure__data"
            >
              <small>{{ $t('component.caseCardModal.priority') }}</small>
              <study-request-priority-dot
                show-label
                :priority="caseStudy.priority"
                :size="9"
              />
            </b-col>
            <b-col
              md="3"
              cols="4"
              class="structure__data"
            >
              <small>{{ $t('component.caseCardModal.requestNumber') }}</small>
              <h4 class="collapsable-card-title">
                {{ caseStudy.requestLabel }}
              </h4>
            </b-col>
            <b-col
              md="3"
              cols="4"
              class="structure__data"
            >
              <small>{{ $t('component.caseCardModal.casRequestDate') }}</small>
              <h4 class="collapsable-card-title">
                {{ caseStudy.requestDate | date }}
              </h4>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <hr>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col
              md="3"
              cols="4"
              class="structure__data"
            >
              <small>{{ $t('component.caseCardModal.pathologist') }}</small>
              <h4 class="collapsable-card-title">
                {{ caseStudy.pathologist }}
              </h4>
            </b-col>
            <b-col
              md="3"
              cols="4"
              class="structure__data"
            >
              <small>{{ $t('component.caseCardModal.resident') }}</small>
              <h4 class="collapsable-card-title">
                {{ caseStudy.resident }}
              </h4>
            </b-col>
            <b-col
              md="2"
              cols="4"
              class="structure__data"
            >
              <small>{{ $t('component.caseCardModal.patientAge') }}</small>
              <h4 class="collapsable-card-title">
                {{ patientTimeOld }}
              </h4>
            </b-col>
            <b-col
              md="2"
              cols="4"
              class="structure__data"
            >
              <small>{{ $t('component.caseCardModal.casInformedDate') }}</small>
              <h4 class="collapsable-card-title">
                {{ caseStudy.informedDate ? caseStudy.informedDate : '-' | date }}
              </h4>
            </b-col>
            <b-col
              md="2"
              cols="4"
              class="structure__data"
            >
              <small>{{ $t('component.caseCardModal.casValidationDate') }}</small>
              <h4 class="collapsable-card-title">
                {{ caseStudy.validationDate ? caseStudy.validationDate : '-' | date }}
              </h4>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="structure__data">
              <small>{{ $t('component.caseCardModal.relevantClinicalData') }}</small>
              <h4 class="collapsable-card-title inside">
                {{ caseStudy.clinicalData }}
              </h4>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="structure__data">
              <small>{{ $t('component.caseCardModal.observations') }}</small>
              <h4 class="collapsable-card-title inside">
                {{ caseStudy.notes }}
              </h4>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>

    <!--Request Data-->
    <b-row>
      <b-col class="form-box">
        <div class="structure">
          <div class="structure__heading">
            <i
              class="far fa-file-export mr-2"
              aria-hidden="true"
            />
            {{ $t('component.caseCardModal.requester') }}
          </div>

          <b-row>
            <b-col>
              <small>{{ $t('component.caseCardModal.cenPhysName') }}</small>
              <h4 class="collapsable-card-title inside">
                {{ caseStudy.physicianDepartment ?
                  caseStudy.physicianDepartment.center.name : '-' }}
              </h4>
            </b-col>
            <b-col>
              <small>{{ $t('component.caseCardModal.unit') }}</small>
              <h4 class="collapsable-card-title inside">
                {{ caseStudy.physicianDepartment ?
                  caseStudy.physicianDepartment.name : '-' }}
              </h4>
            </b-col>
            <b-col>
              <small>{{ $t('component.caseCardModal.professional') }}</small>
              <h4 class="collapsable-card-title inside">
                {{ caseStudy.physicianPetitioner }}
              </h4>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>

    <!--Destination Data-->
    <b-row>
      <b-col class="form-box">
        <div class="structure">
          <div class="structure__heading">
            <i
              class="far fa-file-import mr-2"
              aria-hidden="true"
            />
            {{ $t('component.caseCardModal.destination') }}
          </div>

          <b-row>
            <b-col>
              <small>{{ $t('component.caseCardModal.cenPhysName') }}</small>
              <h4 class="collapsable-card-title inside">
                {{ caseStudy.destinationDepartment ?
                  caseStudy.destinationDepartment.center.name : '-' }}
              </h4>
            </b-col>
            <b-col>
              <small>{{ $t('component.caseCardModal.unit') }}</small>
              <h4 class="collapsable-card-title inside">
                {{ caseStudy.destinationDepartment ?
                  caseStudy.destinationDepartment.name : '-' }}
              </h4>
            </b-col>
            <b-col>
              <small>{{ $t('component.caseCardModal.sendTo') }}</small>
              <h4 class="collapsable-card-title inside">
                {{ caseStudy.attn ? caseStudy.attn : '-' }}
              </h4>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
    <div
      slot="modal-footer"
      class="footer-banner px-2"
      style="width:100%;"
    >
      <div class="row">
        <div class="col-6 text-left">
          <b-button
            size="sm"
            variant="outline-secondary"
            data-dismiss="modal"
            @click="hide"
          >
            {{ $t('global.cancel') }}
          </b-button>
        </div>
        <!-- <div class="col-6 text-right">
          <b-button size="sm" class="btn--primary"><i class="fal fa-print mr-2" aria-hidden="true"></i>{{ $t('global.print') }}</b-button>
        </div> -->
      </div>
    </div>
  </b-modal>
</template>

<script>
import StudyRequestPriorityDot from '@/modules/clinicalModule/components/StatusRequestPriorityDot'

export default {
    name: 'ModalCaseCard',
    components: {
        StudyRequestPriorityDot
    },
    props: {
        caseStudy: { type: Object, required: true }
    },
    computed: {
        patientTimeOld() {
            if (this.caseStudy.patient) return this.getPatientTimeOld(this.caseStudy.patient.patBirthdate)
            return ''
        }
    },
    methods: {
        show() {
            this.$refs.bModal.show()
        },
        hide() {
            this.$refs.bModal.hide()
        }
    }
}
</script>

<style lang="scss">

  .modalPatientCases .modal-body {
    padding: 0.6rem 1.1rem 0 1.1rem !important;
  }

</style>

<style scoped>

  .collapsable-card-title {
    font-weight: normal;
  }

</style>
